import React, { useEffect, useState } from "react";
import {
  decodeFiltersFromQueryString,
  getSelectedFilterItemArr,
  mergeAppliedFilters,
  removeFilters,
} from "../../utils/UtilityMethod";
import CatalogFilterMain from "./CatalogFilterMain";
import "./CatalogFilterSection.css";

function CatalogFilterSection({ filters, cbCallback, searchParams, filterQs }) {
  const [filtersSelectedArr, setFiltersSelectedArr] = useState([]);

  // let filterQs = searchParams.get("f") || "";
  useEffect(() => {
    setFiltersSelectedArr(getSelectedFilterItemArr(filterQs, true));
  }, [filterQs]);

  const onFilterCbClick = (item, isChecked) => {
    decodeFiltersFromQueryString(filterQs).then((data) => {
      if (isChecked) {
        mergeAppliedFilters(data, item).then((res) => {
          cbCallback(res);
        });
      } else {
        removeFilters(data, item).then((res) => {
          cbCallback(res);
        });
      }
    });
  };

  const handleRemove = (item) => {
    item = {
      choice_type: "multiple",
      title: "id_attribute_group|" + item?.title,
      items: [
        {
          // id: item?.id,
          url_slug: item?.url_slug,
          name: item?.name,
        },
      ],
    };
    onFilterCbClick(item, false);
  };

  return (
    <aside className="side-filter-panel mt-20">
      <div className="row">
        <div className="col-12">
          <div className="filter-by">
            <h5>Filter by</h5>
            <ul className="tags" id="filter-by-list-items" style={{ overflowY: "auto", maxHeight: "100px" }}>
              {filtersSelectedArr?.map((item, index) => {
                return (
                  <li key={index} id={item.url_slug} className="filter-by-label">
                    <span id={"darve-filter-label-id" + item.url_slug}>{item.name}</span>
                    <img
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/icons/Cross-Button.png"
                      }
                      alt=""
                      onClick={() => handleRemove(item)}
                    />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div className="col-12">
          <div className="accordion accordion-flush" id="main_dropdown">
            {filters.map((filter, index) => {
              /**
               * @BOC
               * @Support #157051-Implement Changes On Staging Server Such that Filters are Listed on Category Page from Typesense
               * @author Mohammad Meraj
               * @date 02-Jan-2025
               * @use_of_code: The category is now displayed in the filters section, which was not included previously.
               * This change ensures that categories are treated as part of the filters, providing users with more options to refine their search directly from the filters section.
               */
              // if (filter?.id === "category") {
              //   return null;
              // }
              /**
               * EOC
               */
              return (
                <CatalogFilterMain
                  key={index}
                  onFilterCbClick={onFilterCbClick}
                  filter={filter}
                  searchParams={searchParams}
                  filterQs={filterQs}
                />
              );
            })}
          </div>
        </div>
      </div>
    </aside>
  );
}

export default CatalogFilterSection;
